var _rect, _text, _text2, _text3, _g, _g2, _g3, _g4, _text4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCase6Fig1DecisionsToMechanisms(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1200 620",
    fontFamily: "Geist, 'Segoe UI', -apple-system, sans-serif",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1200,
    height: 620,
    fill: "#FFFDF7"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 52,
    fontSize: 22,
    fontWeight: 600,
    fill: "#1A2F2A"
  }, "Every design decision, paired with the mechanism that enforces it")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 76,
    fontSize: 14,
    fill: "#4A5F56"
  }, "A rule a contributor can forget is a rule the product loses, so each one runs somewhere in the pipeline")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 118,
    fontSize: 11,
    letterSpacing: "0.1em",
    fill: "#6B7F74",
    fontWeight: 600
  }, "DECISION")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fontSize: 11.5,
    fill: "#16A34A",
    fontWeight: 600,
    textAnchor: "middle"
  }, /*#__PURE__*/React.createElement("text", {
    x: 668,
    y: 118
  }, "AUTHORING"), /*#__PURE__*/React.createElement("text", {
    x: 808,
    y: 118
  }, "CI GATE"), /*#__PURE__*/React.createElement("text", {
    x: 948,
    y: 118
  }, "POST-AUTHOR HOOK"), /*#__PURE__*/React.createElement("text", {
    x: 1112,
    y: 118
  }, "HARNESS"))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    stroke: "#EEF2EF",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("line", {
    x1: 668,
    y1: 130,
    x2: 668,
    y2: 524
  }), /*#__PURE__*/React.createElement("line", {
    x1: 808,
    y1: 130,
    x2: 808,
    y2: 524
  }), /*#__PURE__*/React.createElement("line", {
    x1: 948,
    y1: 130,
    x2: 948,
    y2: 524
  }), /*#__PURE__*/React.createElement("line", {
    x1: 1112,
    y1: 130,
    x2: 1112,
    y2: 524
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    fontSize: 13.5,
    fill: "#1A2F2A"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 140,
    width: 560,
    height: 66,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 168,
    fontWeight: 600
  }, "No em dashes anywhere a reader can see"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 190,
    fontSize: 12,
    fill: "#4A5F56"
  }, "Four enforcement layers, because one rule kept slipping through"), /*#__PURE__*/React.createElement("circle", {
    cx: 668,
    cy: 173,
    r: 7,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808,
    cy: 173,
    r: 7,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 948,
    cy: 173,
    r: 7,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1112,
    cy: 173,
    r: 7,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 218,
    width: 560,
    height: 66,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 246,
    fontWeight: 600
  }, "Green marks interactive elements only"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 268,
    fontSize: 12,
    fill: "#4A5F56"
  }, "The build fails on a raw color literal"), /*#__PURE__*/React.createElement("circle", {
    cx: 668,
    cy: 251,
    r: 7,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808,
    cy: 251,
    r: 7,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 948,
    cy: 251,
    r: 5,
    fill: "#E2E8E4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1112,
    cy: 251,
    r: 5,
    fill: "#E2E8E4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 296,
    width: 560,
    height: 66,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 324,
    fontWeight: 600
  }, "One typeface, with tabular numerals"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 346,
    fontSize: 12,
    fill: "#4A5F56"
  }, "Chosen by elimination, then locked in the token layer"), /*#__PURE__*/React.createElement("circle", {
    cx: 668,
    cy: 329,
    r: 7,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808,
    cy: 329,
    r: 7,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 948,
    cy: 329,
    r: 5,
    fill: "#E2E8E4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1112,
    cy: 329,
    r: 5,
    fill: "#E2E8E4"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 374,
    width: 560,
    height: 66,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#E2E8E4",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 402,
    fontWeight: 600
  }, "One word for one action, everywhere"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 424,
    fontSize: 12,
    fill: "#4A5F56"
  }, "So a customer never has to learn two names for the same step"), /*#__PURE__*/React.createElement("circle", {
    cx: 668,
    cy: 407,
    r: 7,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808,
    cy: 407,
    r: 7,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 948,
    cy: 407,
    r: 7,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1112,
    cy: 407,
    r: 7,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 452,
    width: 560,
    height: 66,
    rx: 10,
    fill: "#FFFFFF",
    stroke: "#16A34A",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 480,
    fontWeight: 600
  }, "Play, operation, playbook"), /*#__PURE__*/React.createElement("text", {
    x: 72,
    y: 502,
    fontSize: 12,
    fill: "#4A5F56"
  }, "Four words that named five different things, renamed by codemod in a single day"), /*#__PURE__*/React.createElement("circle", {
    cx: 668,
    cy: 485,
    r: 7,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 808,
    cy: 485,
    r: 7,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 948,
    cy: 485,
    r: 5,
    fill: "#E2E8E4"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 1112,
    cy: 485,
    r: 7,
    fill: "#16A34A"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    fontSize: 12,
    fill: "#6B7F74"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 556,
    r: 6,
    fill: "#16A34A"
  }), /*#__PURE__*/React.createElement("text", {
    x: 76,
    y: 561
  }, "enforced at this moment"), /*#__PURE__*/React.createElement("circle", {
    cx: 272,
    cy: 556,
    r: 5,
    fill: "#E2E8E4"
  }), /*#__PURE__*/React.createElement("text", {
    x: 288,
    y: 561
  }, "not applicable"))), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 596,
    fontSize: 13.5,
    fill: "#1A2F2A",
    fontWeight: 500
  }, "The machine holds the floor, which leaves the taste budget for what a person is actually better at deciding.")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCase6Fig1DecisionsToMechanisms);
export default __webpack_public_path__ + "static/media/case6-fig1-decisions-to-mechanisms.789ed4fab00e9176856f44d888ae9619.svg";
export { ForwardRef as ReactComponent };